import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from './AuthContext.jsx';

export const ProtectedRoutes = () => {    
    const auth = useAuth();

    return (
        auth.currentUser && auth.currentUser.emailVerified ?
            <Outlet /> :
            <Navigate to="/" />
    );
}